import {
  CustomerToggleBasedPermissionKeys,
  CustomerToggleBasedPermissions
} from '../WidgetUserCreation.types'

enum CustomerRoleEnum {
  FINISHER = 'FINISHER',
  ORDER_PLACER = 'ORDER_PLACER',
  ACCOUNTANT = 'ACCOUNTANT',
  SUPERINTENDENT = 'SUPERINTEDENT'
}

// eslint-disable-next-line complexity
export const customerRoleSetup = (permissions: CustomerToggleBasedPermissions): string[] => {
  if (
    permissions[CustomerToggleBasedPermissionKeys.canCreateOrders] &&
    permissions[CustomerToggleBasedPermissionKeys.canChangeOrders] &&
    !permissions[CustomerToggleBasedPermissionKeys.canSeeInvoices]
  ) {
    return [CustomerRoleEnum.ORDER_PLACER]
  }

  if (
    permissions[CustomerToggleBasedPermissionKeys.canCreateOrders] &&
    !permissions[CustomerToggleBasedPermissionKeys.canChangeOrders] &&
    !permissions[CustomerToggleBasedPermissionKeys.canSeeInvoices]
  ) {
    return [CustomerRoleEnum.ORDER_PLACER]
  }

  if (
    !permissions[CustomerToggleBasedPermissionKeys.canCreateOrders] &&
    permissions[CustomerToggleBasedPermissionKeys.canChangeOrders] &&
    !permissions[CustomerToggleBasedPermissionKeys.canSeeInvoices]
  ) {
    return [CustomerRoleEnum.SUPERINTENDENT]
  }

  if (
    !permissions[CustomerToggleBasedPermissionKeys.canCreateOrders] &&
    permissions[CustomerToggleBasedPermissionKeys.canChangeOrders] &&
    permissions[CustomerToggleBasedPermissionKeys.canSeeInvoices]
  ) {
    return [CustomerRoleEnum.ACCOUNTANT, CustomerRoleEnum.SUPERINTENDENT]
  }

  if (
    !permissions[CustomerToggleBasedPermissionKeys.canCreateOrders] &&
    !permissions[CustomerToggleBasedPermissionKeys.canChangeOrders] &&
    permissions[CustomerToggleBasedPermissionKeys.canSeeInvoices]
  ) {
    return [CustomerRoleEnum.ACCOUNTANT]
  }

  if (
    permissions[CustomerToggleBasedPermissionKeys.canCreateOrders] &&
    permissions[CustomerToggleBasedPermissionKeys.canChangeOrders] &&
    permissions[CustomerToggleBasedPermissionKeys.canSeeInvoices]
  ) {
    return [CustomerRoleEnum.ACCOUNTANT, CustomerRoleEnum.ORDER_PLACER]
  }

  return [CustomerRoleEnum.FINISHER]
}
